export const DUPLICATE_SCHEDULE_GROUP_MESSAGE =
    "A group with this name already exists";

export function isExistingScheduleGroupName(
    name: string,
    existingGroupNames: readonly string[],
): boolean {
    const normalizedName = name.trim().toLowerCase();
    if (normalizedName === "") {
        return false;
    }
    return existingGroupNames.some(
        (groupName) => groupName.trim().toLowerCase() === normalizedName,
    );
}
